import {DigitalAssetVisual} from '@cohort/components-xps/components/DigitalAssetVisual';
import Title from '@cohort/components-xps/components/Title';
import {NftTransferAcceptButton} from '@cohort/wallet/components/space/nftTransfer/NftTransferAcceptButton';
import {NftTransferSenderMessage} from '@cohort/wallet/components/space/nftTransfer/NftTransferSenderMessage';
import {Subtitle} from '@cohort/wallet/components/Subtitle';
import type {DigitalAssetTransferInvitationWDto} from '@cohort/wallet-schemas/ownership';
import React from 'react';
import {useTranslation} from 'react-i18next';

type AboutNftTransferPanelProps = {
  transferCtaEnabled: boolean;
  nftTransferInvitation: DigitalAssetTransferInvitationWDto;
  handleAcceptNftButtonClicked?: () => Promise<void>;
};

const AboutNftTransferPanel: React.FC<AboutNftTransferPanelProps> = ({
  transferCtaEnabled,
  nftTransferInvitation,
  handleAcceptNftButtonClicked,
}) => {
  const {t} = useTranslation('components', {keyPrefix: 'space.aboutNftTransferPanel'});

  return (
    <div className="h-full px-4 pt-8 md:px-0">
      <div className="no-scrollbar mx-auto mt-5 w-1/2 md:mx-0 md:mt-0 md:min-h-[150px] md:w-auto md:max-w-full md:overflow-auto">
        <DigitalAssetVisual
          digitalAssetImageFileKey={nftTransferInvitation.digitalAssetImageFileKey}
          animationFileKey={nftTransferInvitation.animationFileKey}
        />
      </div>

      <div className="mt-8 text-center md:text-left">
        <Title content={nftTransferInvitation.collection.title} />
        <Subtitle
          classes="text-center md:text-left"
          testId="subtitle-sender-information"
          content={t('senderInformation', {
            senderEmail: nftTransferInvitation.senderEmail,
          })}
        />

        <NftTransferSenderMessage nftTransferInvitation={nftTransferInvitation} />

        {transferCtaEnabled && handleAcceptNftButtonClicked && (
          <div className="mt-5">
            <NftTransferAcceptButton onAcceptNftButtonClicked={handleAcceptNftButtonClicked} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AboutNftTransferPanel;
